<template>
    <main class="main">
        <div class="container-fluid clear-padding">
            <router-view></router-view>
        </div>
    </main>
</template>

<script>
    import { mapGetters } from 'vuex';
    
    export default {
        name: 'gofix-main-container',
        components: {

        },
        data() {
            return {
                logoutTimer:null
            }
        },
        computed: {
            
        },
        watch: {
            $route: {
                immediate: true,
                handler(to) {
                    document.title = to.meta.title || 'Loading...';
                }
            },
        },
        async created() {

        },
        destroyed() {
            
        },
        async mounted() {
            
        },
        methods: {

        },
    }
  </script>